import { Row } from 'react-bootstrap';
import getCardWidthClass from '../../../utils/helpers/cardWidthClass';
import CardHead from './CardHead';
import '../../../assets/styles/components/Card.css';

/**
 * Card skeleton shared by Container and ContainerBlue — head, body and footer
 * live here once so the variants only declare what differs.
 * @param {string} [variant] - 'blue' for the gradient banner; omit for the plain card
 * @param {string|number} [width] - Legacy width prop, resolved to a Card.css modifier
 * @param {boolean} [wrapRow] - Wrap children in a Bootstrap Row (Container's grid body)
 * @param {React.ReactNode} [btns] - Footer content; the footer is skipped when empty
 * @param {React.ReactNode} [headAction] - Optional control shown on the right side of the header
 */
const CardShell = ({ variant, width, title, titleFallback, label, btns, headAction, className = '', wrapRow = false, children }) => {
  const cardClasses = ['te-card', variant && `te-card--${variant}`, getCardWidthClass(width), className].filter(Boolean).join(' ');

  return (
    <div className={cardClasses}>
      <CardHead title={title} titleFallback={titleFallback} label={label} action={headAction} />
      <div className="te-card-body">{wrapRow ? <Row className="mx-auto">{children}</Row> : children}</div>
      {btns && <div className="te-card-foot">{btns}</div>}
    </div>
  );
};

export default CardShell;
